module.exports = __webpack_public_path__ + "static/media/helpers.d9f95d03.png";